/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { SVGIcon } from '@superops/super-icons';
import { ServiceCatalogItem } from '@nile/types';

function SelectedServiceItems({
  selectedServiceItems,
  onDeleteHandler,
  isDisabled = false
}: {
  selectedServiceItems: ServiceCatalogItem[];
  onDeleteHandler: (itemId: string) => void;
  isDisabled?: boolean;
}) {
  if (!selectedServiceItems?.length) return null;
  return (
    <div className="fx actr g10 wrap">
      {selectedServiceItems?.map((item) => {
        return (
          <div className="fx actr g10 lightpurple-to-black-bg p5 pl10 pr10 br-5">
            {item?.name}
            {!isDisabled && (
              <span
                className="fx ptr"
                onClick={() => onDeleteHandler(item?.itemId)}
              >
                <SVGIcon name="Delete" size="sm" />
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default SelectedServiceItems;
